import * as Sentry from "@sentry/react";

function getDsn(): string | undefined {
  // Prefer meta tag for easy runtime injection without env vars
  const meta = document.querySelector('meta[name="sentry-dsn"]') as HTMLMetaElement | null;
  if (meta?.content) return meta.content;
  // Fallback to global if set by hosting platform
  // @ts-ignore
  if (typeof window !== 'undefined' && window.SENTRY_DSN) return (window as any).SENTRY_DSN as string;
  return undefined;
}

export function initSentry() {
  const dsn = getDsn();
  if (!dsn) return; // No-op if DSN not provided

  Sentry.init({
    dsn,
    tracesSampleRate: 0.1,
    replaysSessionSampleRate: 0.0,
    integrations: (integrations) => integrations,
    environment: /localhost|127\.0\.0\.1/.test(window.location.hostname) ? 'development' : 'production',
    beforeSend(event) {
      // Scrub PII from Sentry events
      if (event.user) {
        delete event.user.email;
        delete event.user.ip_address;
      }
      
      // Scrub sensitive data from error messages and stack traces
      if (event.exception) {
        event.exception.values?.forEach(exception => {
          if (exception.value) {
            exception.value = exception.value.replace(/[\w._%+-]+@[\w.-]+\.[A-Za-z]{2,}/g, '[EMAIL_REDACTED]');
            exception.value = exception.value.replace(/\+?[\d\s()-]{10,}/g, '[PHONE_REDACTED]');
            exception.value = exception.value.replace(/\b[A-Za-z0-9+/]{20,}={0,2}\b/g, '[TOKEN_REDACTED]');
          }
        });
      }
      
      // Scrub URLs and request data
      if (event.request) {
        if (event.request.url) {
          event.request.url = event.request.url.replace(/[?&]token=[^&]+/g, '?token=[REDACTED]');
        }
        if (event.request.data) {
          try {
            const data = typeof event.request.data === 'string' ? JSON.parse(event.request.data) : event.request.data;
            if (data.email) data.email = '[EMAIL_REDACTED]';
            if (data.phone) data.phone = '[PHONE_REDACTED]';
            if (data.token) data.token = '[TOKEN_REDACTED]';
            event.request.data = JSON.stringify(data);
          } catch {
            // If parsing fails, just leave as is
          }
        }
      }
      
      return event;
    }
  });
}

export const SentryErrorBoundary = Sentry.ErrorBoundary;
